import {
    ContentType,
    IPictureFileMetadataResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import { useBatchQuery } from 'custom_hooks/useBatchQuery';
import { useCallback } from 'react';
import { Filter, queryAll } from 'utils/query_v3';

const QueryBatchSize = 5;

export type LoadChildFolderOptions = Readonly<{
    parentId: string;
    onSuccess: (children: IPictureFileMetadataResponse[]) => void;
    onError?: () => void;
}>;

export function useFolderLoader() {
    const { enqueue, queuedKeys: loadingIds } = useBatchQuery(QueryBatchSize);

    const loadChildFolders = useCallback(
        ({ parentId, onSuccess, onError }: LoadChildFolderOptions) => {
            enqueue<IPictureFileMetadataResponse[]>([
                {
                    key: parentId,
                    query: () =>
                        queryAll((page) =>
                            sdClient.getFiles({
                                groupIds: [],
                                filter: Filter.and(
                                    Filter.eq('FileType', ContentType.Folder),
                                    Filter.eq('ParentFolderId', parentId)
                                ),
                                page,
                            })
                        ),
                    onSuccess,
                    onError,
                },
            ]);
        },
        [enqueue]
    );

    return {
        loadingIds,
        loadChildFolders,
    };
}
